<mat-dialog-content [formGroup]="form">
	<div class="grid-x grid-margin-x">
		<div class="cell">
			<p class="description" [innerHTML]="data.textkeyPrefix + '.energy.map.description.1' | translate"></p>
		</div>

		<div class="cell">
			<div role="alert" class="form-errors" *ngIf="error" [innerHTML]="(data.textkeyPrefix + '.energy.map.error.' + error) | translate: errorPlaceholders"></div>
		</div>
		<div class="cell small-8">
			<div class="input-group">
				<input type="text" class="input-group-field" id="street" name="street" formControlName="energy-map-street" value=""
					   [placeholder]="data.textkeyPrefix + '.energy.map.street.placeholder' | translate"
					   [matAutocomplete]="autocompleteStreet">
				<mat-autocomplete autoActiveFirstOption #autocompleteStreet="matAutocomplete">
					<mat-option *ngFor="let option of filteredOptions | async" [value]="option">
						{{option}}
					</mat-option>
				</mat-autocomplete>
			</div>
		</div>
		<div class="cell small-4">
			<input type="text" class="input-group-field" id="house_number" name="house_number" formControlName="energy-map-house_number" value=""
				   [placeholder]="data.textkeyPrefix + '.energy.map.house_number.placeholder' | translate">
		</div>
		<div class="cell">
			<p class="hinweis" [innerHTML]="data.textkeyPrefix + '.energy.map.address.hinweis' | translate"></p>
		</div>
	</div>
</mat-dialog-content>

<mat-dialog-actions>
	<div class="grid-x grid-margin-x">
		<div class="cell shrink medium-2">
			<a class="button darker-gray hollow" [mat-dialog-close]="'back'"><i class="icon-chevron-left"></i></a>
		</div>
		<div class="cell auto medium-10">
			<button class="button primary inline-arrow-right search" (click)="submitSearch()" [innerHTML]="data.textkeyPrefix + '.energy.map.search' | translate"></button>
		</div>
	</div>
</mat-dialog-actions>
